import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'

import 'swiper/css/bundle'
import 'swiper/css/pagination'

const sliderHowWorkAboutUs = () => {
  let swiper

  function initSwiper () {
    const screenWidth = document.documentElement.clientWidth

    if (screenWidth < 1180 && swiper === undefined) {
      swiper = new Swiper('#how-work', {
        modules: [Pagination],
        grabCursor: true,
        autoHeight: true,
        speed: 800,
        slidesPerView: 1,
        spaceBetween: 8,
        pagination: {
          el: '#how-work .swiper-pagination'
        },
        breakpoints: {
          500: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          900: {
            slidesPerView: 3,
            spaceBetween: 32
          }
        }
      })
    } else if (screenWidth >= 1180 && swiper !== undefined) {
      swiper.destroy(true, true)
      swiper = undefined
      document.querySelector('#how-work .swiper-wrapper').removeAttribute('style')
      document.querySelector('#how-work .swiper-slide').removeAttribute('style')
      document.querySelector('#how-work .swiper-pagination').style.display = 'none'
    }
  }
  initSwiper()
  window.addEventListener('resize', () => {
    initSwiper()
  })

  const swiperWrapper = document.querySelector('#how-work .swiper-wrapper')
  setTimeout(() => {
    swiperWrapper.style.height = 'auto'
  }, 250)
}

export default sliderHowWorkAboutUs
